import React from 'react'

import { faBookmark, faCompass, faEnvelope, faHomeAlt, faLockAlt } from '@fortawesome/pro-regular-svg-icons'
import {
  faBookmark as faBookmarkSolid,
  faCompass as faCompassSolid,
  faEnvelope as faEnvelopeSolid,
  faHomeAlt as faHomeAltSolid,
} from '@fortawesome/pro-solid-svg-icons'
import PropTypes from 'prop-types'

import { AuthShieldComponent } from 'components/AuthShield'
import { FEATURE_NAMES } from 'components/ConfiguredDynamicFeatureProvider/features'
import DynamicFeature from 'components/DynamicFeatureProvider/DynamicFeature'

import MainTabItem from '../components/MainTabItem'
import MessageCenterTabItem from './MessageCenterTabItem'
import MyCollegesTabItem from './MyCollegesTabItem'

const ROOT = import.meta.env.BASE_URL
const DASH_URL = `${ROOT}/dashboard`
const DISC_URL = `${ROOT}/discover`
const DISC_COLLEGES_URL = `${ROOT}/discover/search`
const MYCO_URL = `${ROOT}/my-colleges`
const MESS_URL = `${ROOT}/message-center`
const OUTR_URL = `${MESS_URL}/outreach`
const DASH_REGEX = new RegExp(DASH_URL)
const DISC_REGEX = new RegExp(DISC_URL)
const MYCO_REGEX = new RegExp(MYCO_URL)
const MESS_REGEX = new RegExp(MESS_URL)

export const propsUnauthed = {
  activeIcon: faLockAlt,
  inactiveIcon: faLockAlt,
  disabled: true,
}

/**
 * Configures tab items for header navigation
 * @param {object} props
 * @prop {string} pathname
 * @returns PageTabs component
 */
const PageTabs = ({ pathname }) => {
  return (
    <>
      <MainTabItem
        title="Home"
        id="main-nav-home"
        url={DASH_URL}
        active={DASH_REGEX.test(pathname)}
        activeIcon={faHomeAltSolid}
        inactiveIcon={faHomeAlt}
      />
      <AuthShieldComponent
        component={MainTabItem}
        title="Discover"
        id="main-nav-discover"
        propsAuthed={{ url: DISC_URL }}
        propsUnauthed={{ url: DISC_COLLEGES_URL }}
        active={DISC_REGEX.test(pathname)}
        activeIcon={faCompassSolid}
        inactiveIcon={faCompass}
      />
      <DynamicFeature name={FEATURE_NAMES.MyColleges}>
        <MyCollegesTabItem
          title="My Colleges"
          id="main-nav-my-colleges"
          url={MYCO_URL}
          active={MYCO_REGEX.test(pathname)}
          activeIcon={faBookmarkSolid}
          inactiveIcon={faBookmark}
        />
      </DynamicFeature>
      <DynamicFeature
        anyName={[FEATURE_NAMES.DirectMessages, FEATURE_NAMES.Notifications, FEATURE_NAMES.OutreachMessages]}
      >
        <MessageCenterTabItem
          title="Inbox"
          id="main-nav-message-center"
          url={OUTR_URL}
          active={MESS_REGEX.test(pathname)}
          activeIcon={faEnvelopeSolid}
          inactiveIcon={faEnvelope}
        />
      </DynamicFeature>
    </>
  )
}

PageTabs.propTypes = {
  pathname: PropTypes.string,
}

export default PageTabs
